import { SELECTOR_MODE } from '~constants';

import { getParticipantMode } from './widgetHelper';

// Helper mockable pour déterminer le mode de sélection des participants
export const ParticipantModeHelper = {
  getMode: (): SELECTOR_MODE => {
    const mode = getParticipantMode();
    if (mode === SELECTOR_MODE.AGE) return SELECTOR_MODE.AGE;
    if (mode === SELECTOR_MODE.CONSUMER_CATEGORY) return SELECTOR_MODE.CONSUMER_CATEGORY;
    return SELECTOR_MODE.AGE;
  },
};
